/**
 * A place for common taskTemplateFilter things
 */
namespace appn.taskTemplateFilter {

    export function init() {
        let value = getStateOrDefault().value;
        const templateIdFromUrl = utils.getUrlParamByName('template');
        if (templateIdFromUrl)
            value = templateIdFromUrl;

        // Auto select the initial default filter
        setValue(value);

        addEvents();
    }

    function addEvents() {
        $('.appnTaskTemplateFilter .appnTaskTemplateFilter-link').off().on('click', function(e) {
            e.preventDefault();
            setValue($(this).prop('id'));
        });
    }

    /**
     * Will get the date filters value from local storage or direct from UI is not in LS.
     */
    export function getStateOrDefault(): INameValuePair {
        const appnTaskTemplateFilter = $('.appnTaskTemplateFilter');
        return appn.dataTable.getStateOrDefault(appn.saveMeState.getRegisterId(appnTaskTemplateFilter), getValue());
    }

    export function getValue(): string {
        const appnTaskTemplateFilter = $('.appnTaskTemplateFilter');
        const value = appnTaskTemplateFilter.find('li.active .appnTaskTemplateFilter-link').prop('id');
        if (value === 'appnTaskTemplateFilter-all')
            return appn.emptyString;

        return value;
    }

    export function setValue(value?: string) {
        appn.dataTable.uncheckAllRowsBox();

        if (getValue() === value)
            return; // No need to set if already the same

        // Set the active class
        const appnTaskTemplateFilter = $('.appnTaskTemplateFilter');
        appnTaskTemplateFilter.find('li').removeClass('active');
        appnTaskTemplateFilter.find('#' + (!value ? 'appnTaskTemplateFilter-all' : value)).closest('li').addClass('active');
    }

    export function reset() {
        setValue();
    }

    export function listContains(value: string) {
        let exists = false;
        const templates = $('.appnTaskTemplateFilter .appnTaskTemplateFilter-link');
        $(templates).each((function(this: any): boolean {
            if ((this).id === 'appnTaskTemplateFilter-all')
                return true;

            if ((this).id === value) {
                exists = true;
                return false;
            }

            return true;
        } as any));

        return exists;
    }
}
